import { Eye, Shield, TrendingUp } from "lucide-react";

const features = [
  {
    icon: Eye,
    title: "Your entire financial life in one view",
    description:
      "Accounts, bills, subscriptions, due dates, and balances all organized in a single dashboard.",
  },
  {
    icon: Shield,
    title: "Stay ahead of every payment",
    description:
      "AI flags upcoming bills, failing autopays, expiring cards, and anything that could slip through the cracks.",
  },
  {
    icon: TrendingUp,
    title: "Real insight into your spending and habits",
    description:
      "Clear patterns, monthly trends, and simple forecasting that help you plan and make smarter financial decisions.",
  },
];

const Solution = () => {
  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <div style={styles.header}>
          <h2 style={styles.title}>
            Everything organized.
            <span style={styles.titleAccent}>Nothing missed.</span>
          </h2>
        </div>

        <div style={styles.grid}>
          {features.map((feature, index) => (
            <FeatureCard key={index} feature={feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

const FeatureCard = ({ feature }: { feature: (typeof features)[0] }) => {
  const Icon = feature.icon;

  return (
    <div style={styles.card}>
      <div style={styles.iconWrapper}>
        <Icon style={styles.cardIcon} />
      </div>
      <h3 style={styles.cardTitle}>{feature.title}</h3>
      <p style={styles.cardDescription}>{feature.description}</p>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  section: {
    padding: "3rem 1rem",
    backgroundColor: "#fff",
  },
  container: {
    maxWidth: "1280px",
    margin: "0 auto",
    padding: "0 1rem",
  },
  header: {
    textAlign: "center",
    marginBottom: "3rem",
  },
  title: {
    fontSize: "clamp(1.75rem, 5vw, 2.5rem)",
    fontWeight: 600,
    marginBottom: "1rem",
    color: "#000",
  },
  titleAccent: {
    display: "block",
    color: "#6366f1",
    marginTop: "0.5rem",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "1.5rem",
    maxWidth: "72rem",
    margin: "0 auto",
  },
  card: {
    padding: "1.5rem",
    backgroundColor: "#fff",
    borderRadius: "1rem",
    border: "1px solid rgba(0,0,0,0.1)",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    transition: "all 0.3s",
  },
  iconWrapper: {
    padding: "0.75rem",
    backgroundColor: "rgba(99, 102, 241, 0.1)",
    borderRadius: "0.75rem",
    width: "fit-content",
    marginBottom: "1rem",
  },
  cardIcon: {
    height: "1.5rem",
    width: "1.5rem",
    color: "#6366f1",
  },
  cardTitle: {
    fontSize: "clamp(1rem, 2.5vw, 1.125rem)",
    fontWeight: 600,
    marginBottom: "0.5rem",
    color: "#000",
  },
  cardDescription: {
    fontSize: "clamp(0.813rem, 2vw, 0.875rem)",
    color: "#6b7280",
    lineHeight: 1.75,
  },
};

export default Solution;
